export default {
  jp: {
    title: {
      list: 'グループアカウント一覧',
      detail: 'アカウント詳細',
      delete: 'アカウント削除'
    },
    error: {
      accountId: {
        notExist: 'アクセスしようとしたアカウントは存在しないか削除されています。最新の情報を確認してください。',
        notExistsGroupAdmin: '他にグループ責任者が存在しないため、設定を変更をすることができません。他のアカウントをグループ責任者に変更のうえ、処理を実施するようお願いいたします。',
        notExistsAdmin: '他に管理者が存在しないため、設定を変更をすることができません。他のアカウントを管理者に変更のうえ、処理を実施するようお願いいたします。'
      }
    },
    label: {
      list: {
        mailAddress: 'ID',
        name: '氏名',
        busho: '部署',
        telNo: '電話番号',
        loginDt: '最終ログイン日時',
        groupAdminFlg: '責任者',
        tempStopFlg: '一時停止'
      },
      detail: {
        mailAddress: 'ID',
        password: 'パスワード',
        name: '氏名',
        group: '所属',
        company: '会社',
        branch: '支社・支局または媒体',
        postNo: '郵便番号',
        prefCd: '都道府県',
        addr1: '市区町村',
        addr2: '番地',
        addr3: 'ビル名',
        busho: '部署',
        telNo: '電話番号',
        remarks: '備考',
        services: '利用希望',
        groupAdminFlg: '責任者設定',
        tempStopFlg: '一時停止設定'
      }
    },
    ph: {
      mailAddress: 'メールアドレスを入力してください',
      name: '氏名を入力してください',
      groupSmall: '選択してください',
      companyId: '選択してください',
      companyName: '「その他」を選択した場合に会社名を入力してください',
      companyNameKana: '「その他」を選択した場合に会社名（カナ）を入力してください',
      branch: '支社・支局または媒体がある場合は選択してください',
      branchName: '「その他」を選択した場合に支社・支局または媒体名を入力してください',
      branchNameKana: '「その他」を選択した場合に支社・支局または媒体名（カナ）を入力してください',
      postNo: '郵便番号を入力してください',
      prefCd: '選択してください',
      addr1: '市区町村を入力してください',
      addr2: '番地を入力してください',
      addr3: 'ビル名を入力してください',
      busho: '部署を入力してください',
      telNo: '電話番号を入力してください',
      password: 'パスワードをリセットする',
      groupAdminFlg: 'グループ責任者に設定する',
      tempStopFlg: 'アカウントを一時的に利用停止に設定する'
    },
    button: {
      new: 'アカウント追加',
      search: '検索',
      reset: '選択行のパスワードをリセット',
      back: '戻る',
      add: '登録する',
      modify: '変更を保存する',
      delete: 'アカウントを削除する'
    },
    desc: {
      list: {
        text0: '所属しているアカウントの一覧です。',
        text1: 'リンクをクリックすることで詳細を表示できます。',
        listCount1: '一覧件数',
        listCount2: '件'
      },
      delete: {
        text1: 'アカウントを削除する場合は、以下のボタンをクリックしてください。'
      }
    }
  },
  en: {
    title: {
      list: 'Accounts',
      detail: 'Account Details',
      delete: 'Delete Account'
    },
    error: {
      accountId: {
        notExist: 'The account does not exist or has been deleted. Please check for the latest information.',
        notExistsGroupAdmin: 'You are unable to change the settings because there is no other Group Manager. Please change the other account to Group Manager to process.',
        notExistsAdmin: 'You are unable to change the settings because there are no other Administrators. Please change the other account to Administrator to process.'
      }
    },
    label: {
      list: {
        mailAddress: 'ID',
        name: 'Name',
        busho: 'Department',
        telNo: 'Phone number',
        loginDt: 'Last login',
        groupAdminFlg: 'Manager setting',
        tempStopFlg: 'Temporarily suspended'
      },
      detail: {
        mailAddress: 'ID',
        password: 'Password',
        name: 'Name',
        group: 'Group',
        company: 'Company/Organization',
        branch: 'Branch',
        postNo: 'Postal code',
        prefCd: 'Prefecture',
        addr1: 'City',
        addr2: 'Street house number',
        addr3: 'Building Name',
        busho: 'Department',
        telNo: 'Phone number',
        remarks: 'Remarks',
        services: 'Services requested',
        groupAdminFlg: 'Manager setting',
        tempStopFlg: 'Temporarily suspended'
      }
    },
    ph: {
      mailAddress: 'Enter your email address',
      name: 'Enter your name',
      groupSmall: 'Select',
      companyId: 'Select',
      companyName: 'Enter your Company/Organization name if you select "Other".',
      companyNameKana: '',
      branch: 'Select if you have a branch office.',
      branchName: 'Enter your Branch name if you select "Other".',
      branchNameKana: '',
      postNo: 'Enter postal code',
      prefCd: 'Select',
      addr1: 'Enter city',
      addr2: 'Enter street house number',
      addr3: 'Enter building name',
      busho: 'Enter department',
      telNo: 'Enter phone number',
      groupAdminFlg: 'Set up as Group Manager',
      tempStopFlg: 'Temporarily Suspend Account'
    },
    button: {
      new: 'Add account',
      search: 'Search',
      reset: 'Reset password for selected items',
      back: 'Back',
      add: 'Register',
      modify: 'Save',
      delete: 'Delete Account'
    },
    desc: {
      list: {
        text0: 'This is the list of your valid accounts.',
        text1: 'Click link to view details.',
        listCount1: 'Count',
        listCount2: 'Items'
      },
      delete: {
        text1: 'Please click below to delete the account.'
      }
    }
  }

}
